(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('MarketplaceDeleteController', MarketplaceDeleteController);

    MarketplaceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Marketplace'];

    function MarketplaceDeleteController($uibModalInstance, entity, Marketplace) {
        var vm = this;

        vm.marketplace = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Marketplace.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
